export default "__VITE_ASSET__kdoyKF4m__"